const ɵ0 = (moment) => {
    return (input) => {
        return moment(input).format("MMM DD, YYYY");
    };
};
const filter = ['moment', ɵ0];
export const FourDotFiveDateFormat = {
    name: 'fourdotfiveDateFormat',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-date-format.filter.js.map